import { render, staticRenderFns } from "./PageVault.vue?vue&type=template&id=6d2cc389&scoped=true&"
import script from "./PageVault.vue?vue&type=script&lang=ts&"
export * from "./PageVault.vue?vue&type=script&lang=ts&"
import style0 from "./PageVault.vue?vue&type=style&index=0&id=6d2cc389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cc389",
  null
  
)

export default component.exports